import { connect } from 'react-redux';
import React from 'react';
import * as selectors from 'app/selectors';
import { FIX_LOCATION } from 'app/constants/hint';
import LocationRoleUsersForm from './LocationRoleUsersForm';

function LocationSettingRepairForm({ updateLocation, users, repairManager }) {
  return (
    <LocationRoleUsersForm
      updateLocation={updateLocation}
      users={users}
      fields={[
        {
          name: 'repair_ids',
          role: 'repair',
          title: '物业负责人',
          hint: FIX_LOCATION.repair,
          selectedUsers: repairManager
        }
      ]}
    />
  );
}

function mapStateToProps(state, props) {
  const { loc_id } = props;
  const manager = selectors.getTeamRolesOfLocation(state, loc_id, 'location_manager');
  let repairManager = selectors.getTeamRolesOfLocation(state, loc_id, 'repair');
  if (repairManager.length == 0) {
    repairManager = manager;
  }

  return {
    users: selectors.getSpaceUsers(state),
    repairManager
  };
}

export default connect(mapStateToProps)(LocationSettingRepairForm);
